<template>
  <div class="trail-box">
    <trailMap :task-detail="taskDetail" />
    <div class="address-box">
      <div
        class="address-item address-destination"
      >
        <div class="address-round round-red" />
        <div v-if="taskDetail.destination">{{ taskDetail.destination }}</div>
        <div
          style="color: #FF8A59;"
          v-else
        >未填写，请到达后和客户确认</div>
        <van-icon
          v-if="canEditDestination"
          @click="editDestination"
          name="edit"
        />
      </div>
    </div>
    <div
      class="fixed-btn"
      @click="showMapNavigation"
    >
      <van-icon name="guide-o" />
      <span>导航到终点</span>
    </div>
    <div class="bottom-box">
      <!-- 底部滑动条 -->
      <ClickButton
        ref="clickButton"
        @sliderCompleted="sliderCompleted"
      >
        点击结束拖车
      </ClickButton>
    </div>
    <!-- 选择地址弹窗 -->
    <SelectLocation
      ref="selectLocation"
      @confirm="locationConfirm"
    />
    <SelectMapNavigation
      ref="selectMapNavigation"
    />
    <!-- 确认弹窗 -->
    <ConfirmDialog
      ref="confirmDialog"
    />
  </div>
</template>

<script>
import trailMap from '../components/trailMap.vue';
import ClickButton from '@/components/clickButton.vue';
import { getTaskDetail } from '@/common/apiPaic.js';
import {
  endWork
} from '@/common/apiGeneral.js';
import getCurrentPositionMixin from '../mixins/getCurrentPositionMixin';
import SelectLocation from '../components/selectLocation.vue';
import SelectMapNavigation from '../components/selectMapNavigation.vue';
import ConfirmDialog from '@/components/confirmDialog.vue';
export default {
  name: 'GeneralOrderTrailing',
  mixins: [getCurrentPositionMixin],
  components: {
    trailMap,
    ClickButton,
    SelectLocation,
    SelectMapNavigation,
    ConfirmDialog
  },
  data() {
    return {
      taskDetail: {},
      orderNo: '',
      taskNo: ''
    };
  },
  created() {
    const { orderNo, taskNo } = this.$route.params;
    if (orderNo && taskNo) {
      this.orderNo = orderNo;
      this.taskNo = taskNo;
    }
  },
  computed: {
    canEditDestination() {
      return this.taskDetail && this.taskDetail.cooperativeOutlet !== 1;
    },
    isCCQC() {
      // 长城汽车
      return this.taskDetail && this.taskDetail.channelCompanyNo === 'CCQC';
    }
  },
  mounted() {
    this.getTaskDetail();
  },
  methods: {
    editDestination() {
      this.$refs.selectLocation.open(this.currentPosition, this.taskNo, this.taskDetail.taskStatus);
    },
    showMapNavigation() {
      if (!this.taskDetail.destination) {
        this.$toast('订单目的地不能为空');
        return;
      }
      this.$refs.selectMapNavigation.open(this.taskDetail.destination, this.taskDetail.destLongitude
                                          , this.taskDetail.destLatitude);
    },
    locationConfirm() {
      this.getTaskDetail();
    },
    async getTaskDetail(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const data = await getTaskDetail({
          orderNo: this.orderNo,
          taskNo: this.taskNo
        });
        if (data) {
          this.taskDetail = data;
        }
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    sliderCompleted() {
      // 长城拖车提审APP，H5，SPS OSS，弹窗提示语：请检查起点和终点是否与实际一致，否则影响结算，只能手动关闭弹窗
      if (this.isCCQC) {
        this.$refs.confirmDialog.open({
          confirmText: '请检查起点和终点是否与实际一致，否则影响结算。',
          cancelButtonText: '返回修改',
          confirmButtonText: '确认提交',
          confirmCallback: () => {
            this.endWork();
          },
          cancelCallback: () => {
          }
        });
      } else {
        this.endWork();
      }
      this.$refs.clickButton.reset();
    },
    // 页面跳转
    toPage(name) {
      const router = {
        name,
        params: {
          orderNo: this.orderNo,
          taskNo: this.taskNo
        }
      };
      this.$router.replace(router);
    },
    async endWork(skipDistanceCheck = false, skipCooperativeOutletCheck = false, noLoading) {
      if (!this.currentPosition) {
        this.$toast('当前位置获取失败，请确认是否打开位置权限！');
        return;
      }
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const res = await endWork({
          taskNo: this.taskDetail.taskNo,
          ...this.currentPosition,
          skipDistanceCheck,
          skipCooperativeOutletCheck
        });

        if (!noLoading) {
          this.$toast.clear();
        }

        console.log('res:', res);

        if (res && res.code) {
          // 结束拖车的时候判断当前位置与平安指定终点偏差是否在500米内
          if (res.code === '7007') {
            const confirmText2 = [
              {
                text: '检测到当前拖车终点与平安指定终点偏差距离过大，如未拖至平安指定合作拖车终点，'
              },
              {
                text: '将扣除70%服务费。',
                color: 'red'
              }
            ];
            this.$refs.confirmDialog.open({
              confirmText2,
              cancelButtonText: '继续拖车',
              confirmButtonText: '终点无误',
              confirmCallback: () => {
                this.endWork(true, true);
              },
              cancelCallback: () => {
                this.$refs.clickButton.reset();
              }
            });
          } else if (res.code === '7003') {
            // 距离超过500m
            await this.$dialog.confirm({
              title: '提示',
              message: res.message || '您距离拖车目的地似乎还有一段距离，是否确认已经到达现场？',
              confirmButtonColor: '#3399FF'
            });
            this.endWork(true, true);
          }
        } else {
          this.toPage('GeneralOrderTrailCompleted');
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.trail-box{
  .address-box{
    position: fixed;
    z-index: 2;
    top: 56px;
    right: 10px;
    left: 10px;

    padding: 12px;

    border-radius: 10px;
    background-color: #fff;
    .address-item{
      display: flex;
      align-items: baseline;

      color: #383838;

      font-size: 14px;
      line-height: 21px;

      & + .address-item{
        margin-top: 12px;
      }

      .address-round{
        flex: 10px 0 0;

        width: 10px;
        height: 10px;
        margin-right: 8px;

        border-radius: 100%;
        &.round-green{
          background-color: #76C16D;
        }
        &.round-red{
          background-color: #EF9164;
        }
      }
      &.address-destination{
        color: #7A7F7F;
      }

      .van-icon{
        margin-left: 8px;

        font-size: 16px;
      }
    }
  }
  .fixed-btn{
    position: fixed;
    right: 6px;
    bottom: 150px;

    padding: 10px;

    color: #3399FF;
    border-radius: 100px 0 0 100px;
    background: #fff;

    font-size: 12px;
    .van-icon-guide-o{
      margin-right: 8px;
    }
  }
  .bottom-box{
    position: fixed;
    z-index: 2;
    bottom: 0;

    width: 100vw;
  }
}
</style>
